import React, { useEffect, useRef, useState } from 'react';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { LifeCycle } from '@process-advisor/process-miner/time/lifecycle/lifecycle'
import {
    StyledWrapper,
    StyledContent,
    StyledModal,
    StyledHeader,
    StyledIcon,
    StyledFooter,
    StyledTitle,
} from '@process-advisor/process-miner/components/modal/modal.styles'
import { Button } from '@process-advisor/process-miner/components/shared/button';
import { Event } from '@process-advisor/process-miner/api/events';
import styled from 'styled-components';
import { EventDetailGrid } from '@process-advisor/process-miner/time/lifecycle/eventDetailGrid'

const DetailGrid = styled.div`
    width: 1200px;
    height: 300px;
    border: hidden;
    canvas {
        outline: none;
    };
`;

const LifeCycleGraph = styled.div`
    width: 1200px;
    height: 300px;
    border: hidden;
    canvas {
        outline: none;
    };
`;

type Props = {
    props: {
        param: string,
    },
}

export type Data = []

export const LifecycleModalSingle: React.FC = () => {
    const [data, setData] = React.useState<Data[]>([]);
    const [props, setProps] = React.useState<{  param: string}>({ param: ''});
    const [open, setOpen] = React.useState(false);
    const [title, setTitle] = React.useState('');
    const [showCloseIcon, setShowCloseIcon] = React.useState(true);

    function onClose() {
        setOpen(false)
    }
    useApiListener(
        Event.openLifecycleModalSingle,
        ({ props }: Props) => {
            setOpen(true);
            setProps(props);
            setTitle(apiProvider.getEntityUpper() + ' Lifecycle')
        }
    );

    return (
        <StyledWrapper open={open} onClose={onClose}>
            <StyledModal >
                <StyledHeader>
                    <StyledTitle>{title}</StyledTitle>
                    {showCloseIcon ? <StyledIcon onClick={onClose} /> : <div />}
                </StyledHeader>
                <StyledContent>
                    <DetailGrid>
                        <EventDetailGrid/>
                    </DetailGrid> 
                </StyledContent>
                <StyledContent>
                    <LifeCycleGraph>
                        <LifeCycle/>
                    </LifeCycleGraph> 
                </StyledContent>
                <StyledFooter>
                    <Button label='Close' onClick={onClose} disabled={false} />
                </StyledFooter>
            </StyledModal>
        </StyledWrapper>
    );
};

